import { common } from './common.icons';

export const IconFreeShippingListPage = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-truck ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M5.69043 2.7998H13.0703C13.1151 2.79988 13.1456 2.81671 13.166 2.83691C13.1866 2.85733 13.2002 2.88431 13.2002 2.91992V11.2305C13.1999 11.8083 12.7282 12.2801 12.1504 12.2803H3C2.89185 12.2803 2.79985 12.1882 2.7998 12.0801V5.69043C2.7998 4.09226 4.09226 2.7998 5.69043 2.7998Z"
        fill="white"
        stroke="white"
        stroke-width="1.6"
      />
      <path
        d="M15.7002 13C15.7002 14.8218 17.1782 16.2998 19 16.2998H21.2002V17C21.2002 17.9777 20.5669 18.801 19.6875 19.0889C19.277 17.4343 17.7779 16.2002 16 16.2002C14.1824 16.2002 12.6555 17.4898 12.2861 19.2002H11.7139C11.3445 17.4898 9.81756 16.2002 8 16.2002C6.22206 16.2002 4.72189 17.4341 4.31152 19.0889C3.43255 18.8008 2.7998 17.9773 2.7998 17V15C2.7998 14.8918 2.89183 14.7998 3 14.7998H12.5C14.0435 14.7998 15.34 13.7388 15.7002 12.3066V13ZM16 5.7998H16.8398C17.2675 5.7998 17.6672 6.03196 17.8877 6.41113L18.1201 6.81934C16.9814 7.13392 16.0891 8.04339 15.7998 9.19238V6C15.7998 5.89183 15.8918 5.7998 16 5.7998Z"
        fill="white"
        stroke="white"
        stroke-width="1.6"
      />
      <path
        d="M8 18.7998C8.66274 18.7998 9.2002 19.3373 9.2002 20C9.2002 20.6627 8.66274 21.2002 8 21.2002C7.33726 21.2002 6.7998 20.6627 6.7998 20C6.7998 19.3373 7.33726 18.7998 8 18.7998Z"
        fill="white"
        stroke="white"
        stroke-width="1.6"
      />
      <path
        d="M16 18.7998C16.6627 18.7998 17.2002 19.3373 17.2002 20C17.2002 20.6627 16.6627 21.2002 16 21.2002C15.3373 21.2002 14.7998 20.6627 14.7998 20C14.7998 19.3373 15.3373 18.7998 16 18.7998Z"
        fill="white"
        stroke="white"
        stroke-width="1.6"
      />
      <path d="M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z" fill="white" />
    </svg>
  );
};
